var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters } from "vuex";
import BasicArcheivesService from '../../api/BasicArcheivesService';
import { Loading } from 'element-ui';
import AddAndEditStoreSplitRule from './component/AddAndEditStoreSplitRule.vue';
import TableHeaderToolTip from './component/TableHeaderToolTip.vue';
var StoreSplit = (function (_super) {
    __extends(StoreSplit, _super);
    function StoreSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchParams = {
            search_type: '4',
            search: ''
        };
        _this.searchTypeOptions = [
            { value: '4', label: '货品名称' },
            { value: '5', label: '货品类别名称' }
        ];
        _this.selectRows = [];
        _this.tableHeight = 300;
        return _this;
    }
    StoreSplit.prototype.created = function () {
        var _this = this;
        console.log('this.Root_PageAuth', this.Root_PageAuth);
        console.log('this.openedCodeData', this.openedCodeData);
        this.service = BasicArcheivesService.getInstance();
        this.getOrganList().then(function () {
            _this.getStoreSplitList();
        });
    };
    StoreSplit.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 211;
        }, 300);
    };
    StoreSplit.prototype.delStoreSplit = function (data) {
        var _this = this;
        this.$confirm("\u8BF7\u786E\u8BA4\u662F\u5426\u5220\u9664\u8BE5\u5206\u62E3\u89C4\u5219\uFF1F", '提示', {
            customClass: 'confirm',
            confirmButtonText: '确定',
            center: true,
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.delStoreSplit({
                    rule_id: data.rule_id
                }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success("\u5220\u9664\u6210\u529F");
                        _this.getStoreSplitList(_this.pager);
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                    loadingInstance_1.close();
                }, function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                }).catch(function (err) {
                    _this.$message.error(err.message);
                    loadingInstance_1.close();
                });
            }
        }).catch(function () { });
    };
    StoreSplit.prototype.getStoreSplitList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.pager = pager;
        var params = { from_system: 3 };
        if (this.searchParams.search && this.searchParams.search_type) {
            params.search_type = this.searchParams.search_type;
            params.search = this.searchParams.search;
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getStoreSplitList(params).then(function (res) {
            var data = res.data.data;
            _this.listData = data || [];
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.pageChange = function (pager) {
        this.getStoreSplitList(pager);
    };
    StoreSplit.prototype.getOrganList = function () {
        var _this = this;
        return this.service.getOrganList().then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
        });
    };
    StoreSplit.prototype.addStore = function () {
        var _this = this;
        var instance = this.$dialog(AddAndEditStoreSplitRule, {
            data: {
                organList: this.organList,
                ediStatus: this.ediStatus
            }
        }, {
            title: "新增出库规则",
            width: 560,
            height: 400
        }).instance;
        instance.$on("addClient:ok", function (data) {
            _this.getStoreSplitList();
        });
    };
    StoreSplit.prototype.editStore = function (item) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        return this.service.getStoreSplitDetail({
            rule_id: item.rule_id
        }).then(function (res) {
            loadingInstance.close();
            if (!res.data.success) {
                _this.$message.error(res.data.msg);
                return;
            }
            ;
            _this.getFilterData({
                rule_id: item.rule_id,
                from_system: 3,
                depot_id: res.data.data.depot_id,
                scm_delivery_depot_id: res.data.data.scm_delivery_depot_id,
            }).then(function (res2) {
                debugger;
                var instance = _this.$dialog(AddAndEditStoreSplitRule, {
                    data: {
                        storeEditInfo: res.data.data,
                        organList: _this.organList,
                        ediStatus: _this.ediStatus,
                        extra_selected_goods: res2.data.extra_selected_goods,
                        extra_selected_goods_type: res2.data.extra_selected_goods_type
                    }
                }, {
                    title: "\u4FEE\u6539" + res.data.data.rule_name + "\u51FA\u5E93\u89C4\u5219",
                    width: 560,
                    height: 400
                }).instance;
                instance.$on("addClient:ok", function () {
                    _this.getStoreSplitList(_this.pager);
                });
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.getFilterData = function (params) {
        return this.service.getStoreSplitFilterData(params);
    };
    StoreSplit.prototype.getStoreSplitDetail = function (item) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        return this.service.getStoreSplitDetail({
            rule_id: item.rule_id
        }).then(function (res) {
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    StoreSplit.prototype.search = function () {
        this.getStoreSplitList({ page: 1, start: 0, limit: 20 });
    };
    StoreSplit = __decorate([
        Component({
            components: {
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                "ediStatus": "ediStatus"
            })),
            methods: __assign({}, mapActions(["getAuth"]), { renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "采购数量*采购系数+库存数量",
                            placement: "bottom"
                        }
                    }, '机构默认库');
                } })
        })
    ], StoreSplit);
    return StoreSplit;
}(Vue));
export default StoreSplit;
